/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const MediaLibraryHeader = ({
  reloadList = () => {},
  selectedFilter = "all",
  onFilterChange = () => {},
  selectedItemIds = [],
  searchTerm = "",
  onSearchTermChange = () => {},
}) => {
  const { t } = useTranslation();

  const breadcrumbText = [{ title: t("Media Library") }];

  return (
    <div className="bg-white pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2">
          {/* text input for quick search using file name */}
          <input
            type="text"
            className="form-control text-black fs-sm fw-semibold border border-gray-300 shadow-none bg-white"
            placeholder={t("Search by file name")}
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
          />

          {/* <!-- ========== Start refresh Section ========== --> */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* <!-- ========== End refresh Section ========== --> */}

          {/* <!-- ========== Start Media Type Dropdown Section ========== --> */}
          <select
            className="form-select bg-white px-3 py-2 rounded-3 shadow-none border border-gray-300"
            style={{
              height: "45px",
              minWidth: "170px",
              maxWidth: "200px",
              fontSize: "0.875rem", //  small font size
              fontWeight: "600", // normal weight
            }}
            aria-label="Select media type"
            value={selectedFilter}
            onChange={(e) => onFilterChange(e.target.value)}
          >
            <option value="all">{t("All media items")}</option>
            <option value="image">{t("Images")}</option>
            <option value="audio">{t("Audio")}</option>
            <option value="video">{t("Video")}</option>
            <option value="documents">{t("Documents")}</option>
          </select>
          {/* <!-- ========== End Media Type Dropdown Section ========== --> */}

          {/* <!-- ========== Start Action Dropdown Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                    selectedItemIds.length === 0
                      ? "disabled text-muted"
                      : "text-danger"
                  }`}
                  to="#"
                  data-bs-toggle={
                    selectedItemIds.length === 0 ? undefined : "modal"
                  }
                  data-bs-target={
                    selectedItemIds.length === 0 ? undefined : "#deletewarning"
                  }
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <!-- ========== End Action Dropdown Section ========== --> */}

          {/* <!-- ========== Start Add New Section ========== --> */}
          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold w-100"
            data-bs-toggle="offcanvas"
            data-bs-target="#uploadFilePopup"
            aria-controls="uploadFilePopup"
          >
            <span className="material-symbols-outlined icon-md">
              upload_file
            </span>
            <span>{t("Upload File")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MediaLibraryHeader;
